import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ProjectSearchResultEntry, ProjectSelection } from '../../project.model';
import { environment } from 'src/environments/environment';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { HttpService } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';

@Component({
  selector: 'app-project-selection',
  templateUrl: './project-selection.component.html',
  styleUrls: ['./project-selection.component.scss']
})
export class ProjectSelectionComponent {

  isLoading = false;

  get searchProjectsEnabled(): boolean {
    return !this.isLoading && this.formGroup.valid;
  }

  formGroup = new FormGroup({});

  @Output() projectSelected = new EventEmitter<number>();

  displayedColumns: string[] = ['name', 'start-date', 'end-date', 'archived', 'action'];
  datasource = new MatTableDataSource<any>();

  constructor(
    private http: HttpService,
    public translationService: TranslationService
  ) {

    this.formGroup.addControl('name', new FormControl('', []));
    this.formGroup.addControl('startDate', new FormControl('', []));
    this.formGroup.addControl('endDate', new FormControl('', []));
    this.formGroup.addControl('archived', new FormControl('', []));
    this.formGroup.valueChanges.subscribe(formValues => {
    });

    this.searchProjects(new ProjectSelection({}));
  }

  private searchProjects(selection: ProjectSelection) {
    this.isLoading = true;
    this.http.postWithContext<ProjectSearchResultEntry[]>(environment.erpProjectEndpoint + '/searchProjects', selection).subscribe(response => {
      console.log('response is', response);

      let data = new Array<ProjectSearchResultEntry>();
      for (let catalog of response) {
        data.push(new ProjectSearchResultEntry(catalog));
      }

      this.datasource.data = data;
      this.isLoading = false;
    }, error => {
      console.log('error is', error);
      this.isLoading = false;
    });
  }

  public onSearchProjects() {
    const selection = new ProjectSelection({});
    selection.name = this.formGroup.controls.name.value;
    selection.startDate = this.formGroup.controls.startDate.value;
    selection.endDate = this.formGroup.controls.endDate.value;
    selection.archived = this.formGroup.controls.archived.value;
    this.searchProjects(selection);
  }

  public selectProject(project: ProjectSearchResultEntry) {
    this.projectSelected.next(project.id);
  }
}
